function Accordion({
    title,
    icon,
    onToggle,
    open,
    disabled,
    children,
}: {
    title: string;
    icon?: React.ReactNode;
    onToggle: () => void;
    open: boolean;
    disabled?: boolean;
    children: React.ReactNode;
}) {
    return (
        <details
            className={`fireknife-accordion ${disabled ? 'fireknife-accordion--disabled' : ''}`}
            open={open}
        >
            <summary
                className="fireknife-accordion__summary"
                onClick={(e: React.MouseEvent<HTMLDetailsElement>) => {
                    e.preventDefault();
                    if (disabled) {
                        return;
                    }
                    onToggle();
                }}
            >
                {icon && <span className="fireknife-accordion__summary-icon-box">{icon}</span>}
                <span className="fireknife-accordion__summary-title">{title}</span>
            </summary>
            <div className="fireknife-accordion__summary-content">{children}</div>
        </details>
    );
}

export default Accordion;
